import {BaseConverter} from '../../base/converters/base-converter.converter';
import {ArticleModel} from '../models/article.model';
import {Article} from '../../shared/DTO/article';
import {CpaConverter} from './cpa.converter';
import {CpaPriceConverter} from './cpa-price.converter';
import {DurationConverter} from './duration.converter';
import {ProductCompositionConverter} from './product-composition.converter';
import {PropertyConverter} from './property.converter';
import {RequestConverter} from './request.converter';
import {ServiceConverter} from './service.converter';
import {ServicesCombinationConverter} from './service-combination.converter';
import {Injectable} from '@angular/core';
import {TransictionsConverter} from "./transictions.converter";

@Injectable()
export class ArticleConverter extends BaseConverter<ArticleModel, Article> {

  constructor(
    private cpaConverter: CpaConverter,
    private cpaPriceConverter: CpaPriceConverter,
    private durationConverter: DurationConverter,
    private productCompositionConverter: ProductCompositionConverter,
    private propertyConverter: PropertyConverter,
    private requestConverter: RequestConverter,
    private serviceConverter: ServiceConverter,
    private servicesCombinationConverter: ServicesCombinationConverter,
    private transictionsConverter: TransictionsConverter
  ) {
    super();
  }

  convertToDto(model: ArticleModel): Article {
    if (!model) {
      return;
    }
    return {
      additionalDescription: model.additionalDescription,
      admittedStates: model.admittedStates,
      admittedAdditionalRevoke: model.admittedAdditionalRevoke,
      admittedRevoke: model.admittedRevoke,
      admittedTransictionStates: model.admittedTransictionStates,
      appId: model.appId,
      article: model.article,
      code: model.code,
      contractType: model.contractType,
      cpa: this.cpaConverter.convertToDtoList(model.cpa),
      cpaPrices: this.cpaPriceConverter.convertToDtoList(model.cpaPrices),
      deactivationCode: model.deactivationCode,
      description: model.description,
      duration: this.durationConverter.convertToDto(model.duration),
      enabledProfiles: model.enabledProfiles,
      family: model.family,
      identityIpam3: model.identityIpam3,
      identityIsac: model.identityIsac,
      identityLisa: model.identityLisa,
      identityManagedByIsac: model.identityManagedByIsac,
      identityMinosse: model.identityMinosse,
      identitySpid: model.identitySpid,
      isecProfile: model.isecProfile,
      mainDomain: model.mainDomain,
      management: model.management,
      noIdentity: model.noIdentity,
      mandatoryRevokeNote: model.mandatoryRevokeNote,
      optional: model.optional,
      optionalOrder: model.optionalOrder,
      orderTemplate: model.orderTemplate,
      passwordPolicy: model.passwordPolicy,
      postActivationName: model.postActivationName,
      productsCompositions: this.productCompositionConverter.convertToDtoList(model.productsCompositions),
      properties: this.propertyConverter.convertToDtoList(model.properties),
      reactivationCode: model.reactivationCode,
      request: this.requestConverter.convertToDto(model.request),
      secondaryDomains: model.secondaryDomains,
      separateIdentity: model.separateIdentity,
      services: this.serviceConverter.convertToDtoList(model.services),
      servicesCombinations: this.servicesCombinationConverter.convertToDtoList(model.servicesCombinations),
      type: model.type,
      warpFlow: model.warpFlow,
      transictions: this.transictionsConverter.convertToDto(model.transictions),
      active: model.active,
      max: model.active,
    };
  }

  convertToModel(dto: Article): ArticleModel {
    if (!dto) {
      return;
    }

    let model: ArticleModel = new ArticleModel();

    model.additionalDescription = dto.additionalDescription;
    model.admittedStates = dto.admittedStates;
    model.admittedTransictionStates = dto.admittedTransictionStates;
    model.admittedRevoke = dto.admittedRevoke;
    model.admittedAdditionalRevoke = dto.admittedAdditionalRevoke;
    model.appId = dto.appId;
    model.article = dto.article;
    model.code = dto.code;
    model.type = dto.type;
    model.contractType = dto.contractType;
    model.cpa = this.cpaConverter.convertToModelList(dto.cpa);
    model.cpaPrices = this.cpaPriceConverter.convertToModelList(dto.cpaPrices);
    model.deactivationCode = dto.deactivationCode;
    model.description = dto.description;
    model.duration = this.durationConverter.convertToModel(dto.duration);
    model.enabledProfiles = dto.enabledProfiles;
    model.family = dto.family;
    model.identityIpam3 = dto.identityIpam3;
    model.identityIsac = dto.identityIsac;
    model.identityLisa = dto.identityLisa;
    model.identityManagedByIsac = dto.identityManagedByIsac;
    model.identityMinosse = dto.identityMinosse;
    model.identitySpid = dto.identitySpid;
    model.isecProfile = dto.isecProfile;
    model.mainDomain = dto.mainDomain;
    model.management = dto.management;
    model.noIdentity = dto.noIdentity;
    model.mandatoryRevokeNote = dto.mandatoryRevokeNote;
    model.optional = dto.optional;
    model.optionalOrder = dto.optionalOrder;
    model.orderTemplate = dto.orderTemplate;
    model.passwordPolicy = dto.passwordPolicy;
    model.postActivationName = dto.postActivationName;
    model.productsCompositions = this.productCompositionConverter.convertToModelList(dto.productsCompositions);
    model.properties = this.propertyConverter.convertToModelList(dto.properties);
    model.reactivationCode = dto.reactivationCode;
    model.request = this.requestConverter.convertToModel(dto.request);
    model.secondaryDomains = dto.secondaryDomains;
    model.services = this.serviceConverter.convertToModelList(dto.services);
    model.servicesCombinations = this.servicesCombinationConverter.convertToModelList(dto.servicesCombinations);
    model.separateIdentity = dto.separateIdentity;
    model.warpFlow = dto.warpFlow;
    model.transictions = this.transictionsConverter.convertToModel(dto.transictions);
    model.active = dto.active;
    model.max = dto.max;
    return model;
  }
}
